export default {
    skillTooltip: 'keyword belongs to the ',
    skillTooltip2: 'matched section of Skill Match',
    actionTooltip: 'keyword belongs to the found action verbs section',
    // actionTooltip2: 'category action verb',
}